import { DatabaseModel, DatabaseModelElement } from "./DatabaseModel";
import { Grid } from "@mui/material";
import { Visibility } from "@mui/icons-material";
import React from "react";
// @ts-ignore
import { Link } from "react-router";
import Debtor from "./Debtor";

export default class Reseller extends DatabaseModel implements DatabaseModelElement {
  static modelName = "subsReseller";
  constructor(
    public id: number = 0,
    public subs_debtor_id: number | null = null,
    public description: string = "",
    public active: boolean = true,
    public transactionKickback: boolean = false,
    public created_at: Date = new Date(),
    public updated_at: Date = new Date(),
    public deleted_at: Date | null = new Date()
  ) {
    super();
  }

  static CreateModel(model: any): Reseller {
    return new Reseller(
      model.id,
      model.subs_debtor_id,
      model.description,
      model.active,
      model.transactionKickback,
      model.created_at,
      model.updated_at,
      model.deleted_at
    );
  }

  tableRow() {
    return (
      <>
        <Grid item xs={2}>
          {this.description}
        </Grid>
        <Grid item xs={2}>
          {this.subs_debtor_id != null ? (
            <Link to={{ pathname: Debtor.editPath(this.subs_debtor_id) }}>Debtor</Link>
          ) : null}
        </Grid>
        <Grid item xs={2}>
          <Link to={{ pathname: Reseller.editPath(this.id) }}>
            <Visibility />
          </Link>
        </Grid>
      </>
    );
  }
}
